export const Obtain_Home_Music_Score_Data = 'homePage/Obtain_Home_Music_Score_Data';
export const Obtain_Main_Banner = 'homePage/Obtain_Main_Banner';
